import { render, staticRenderFns } from "./SupplierList.vue?vue&type=template&id=2d41eddc&scoped=true&"
import script from "./SupplierList.vue?vue&type=script&lang=ts&"
export * from "./SupplierList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d41eddc",
  null
  
)

export default component.exports